import React, { useState, useEffect } from "react";

// React DateTime
import Datetime from "react-datetime";
import moment from "moment";
import Axios from "axios";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import TeasuryTable from "../../../components/Content/TeasuryTable";
import FileModalV2 from "../../../components/Modal/FileModal2";
import ItemWhModal from "../../../components/Modal/ItemWhsrtModal";

// Utils
// import {
//   formatDateOnChange,
//   formatDateToStringDate,
// } from "../../../../utils/DateUtils";
import {
  parseCurrency,
  getDataWithComp,
  getAlert,
} from "../../../../utils/SamuiUtils";
import { getReport } from "../../../../utils/ReportUtils";

const Main = ({ name, onChangeMode, dataMasterList, dataDetailList }) => {
  const [filteredDetailList, setFilteredDetailList] = useState([]);
  const [whDocNo, setWhDocNo] = useState("");

  // จากคลัง
  const [fromWhId, setFromWhId] = useState("");
  const [fromWhName, setFromWhName] = useState("");
  const [remarkWhName, setRemarkWhName] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showFileModal, setShowFileModal] = useState(false);
  const [openUploadAttach, setOpenUploadAttach] = useState(false);
  const [formDetailList, setFormDetailList] = useState([]);
  console.debug("formDetailList", formDetailList);
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => setShowItemModal(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth);
  const [selectedLeftDocId, setSelectedLeftDocId] = useState(null);

  // ไปคลัง
  const [toWhId, setToWhId] = useState("");
  const [toWhName, setToWhName] = useState("");

  const [fromDate, setFromDate] = useState(moment().startOf("month"));
  const [toDate, setToDate] = useState(moment().endOf("month"));
  const warehouse_Id = localStorage.getItem("WHID");
  const Emp_Position = localStorage.getItem("EmpPosition");

  // ตัวช่วยแปลงวันเป็น พ.ศ. รูปแบบ DD/MM/YYYY
  const fmtThaiDate = (d) => {
    if (!d) return "";
    const m = moment.isMoment(d) ? d.clone() : moment(d);
    return m.add(543, "years").format("DD/MM/YYYY");
  };

  const clearDetail = () => {
    setFilteredDetailList([]);
    setWhDocNo("");
    setFromWhId("");
    setFromWhName("");
    setToWhId("");
    setToWhName("");
    setRemarkWhName("");
    setSelectedFiles([]);
  };

  const onRowSelectItem = (
    itemsSelected,
    {
      fromDatex,
      toDatey,
      selectedWarehouseFrom,
      selectedWarehouseTo,
      selectedCreator,
      whDocRemarks,
      whDocRemarkMap,
      selectedWarehouseFrom2,
    }
  ) => {
    try {
      // ตัดซ้ำตาม WHDoc_Id (fallback: Item_Id)
      const map = new Map();
      for (const it of itemsSelected || []) {
        const id = it?.WHDoc_Id ?? it?.Item_Id;
        if (id != null && !map.has(id)) map.set(id, it);
      }
      const uniques = Array.from(map.values());

      // รวบรวม WHDoc_Id เป็นสตริงคั่นด้วย comma
      const idStr = uniques
        .map((d) => d?.WHDoc_Id ?? d?.Item_Id)
        .filter((v) => v != null && v !== "")
        .join(",");

      // ถ้าเอกสารมีหลายประเภท จะรวมชื่อประเภทแบบไม่ซ้ำคั่นด้วย comma
      const types = Array.from(
        new Set(
          uniques.map((d) => (d?.WHDocType_Name || "").trim()).filter(Boolean)
        )
      );
      const typeStr = types.length === 0 ? "" : types.join(", ");

      // ช่วงวันที่ (พ.ศ.)
      const dateStr = `${fmtThaiDate(fromDatex)} - ${fmtThaiDate(toDatey)}`;

      // อ็อบเจ็กต์ผลลัพธ์ตามฟอร์แมตที่ต้องการ
      const payload = {
        WHDoc_Id: idStr,
        WHDocType_Name: typeStr || "คลังโรงงาน", // ถ้าต้องการบังคับค่าคงที่ ให้ใส่ตรงนี้
        Date:
          dateStr === " - "
            ? `${fmtThaiDate(moment().startOf("month"))} - ${fmtThaiDate(
                moment().endOf("month")
              )}`
            : dateStr,
        selectedCreator: selectedCreator || "ทั้งหมด",
        whDocRemarks: whDocRemarks || "ทั้งหมด",
        whDocRemarkMap: whDocRemarkMap || {},
        selectedWarehouseFrom: selectedWarehouseFrom2 || "ทั้งหมด",
        acc: localStorage.getItem("name") || "system",
      };
      console.debug("onRowSelectItem payload =>", payload);

      const map2 = new Map();
      for (const it of itemsSelected || []) {
        const id = it?.WHDoc_Id ?? it?.Item_Id;
        if (id != null && !map2.has(id)) map2.set(id, it);
      }
      const updated = Array.from(map2.values()).map((d) => ({
        WHDoc_Id: d?.WHDoc_Id ?? d?.Item_Id ?? null,
        WHDocType_Name: d?.WHDocType_Name ?? "",
        fromDate: fromDatex ? fromDatex.toISOString() : null,
        toDate: toDatey ? toDatey.toISOString() : null,
      }));
      setFormDetailList(updated);

      // ถ้าสตรีมเดิมของคุณคาดหวัง "ออบเจ็กต์เดียว" ให้ set แบบนี้:
      // setFormDetailList(payload);

      // ถ้าคาดหวังเป็น "อาร์เรย์" ให้ใช้แบบนี้แทน:
      // setFormDetailList([payload]);
      console.debug("selectedItemType", selectedItemType);
      if (selectedItemType === 3) {
        getReport("SUM_WHDOC_3", payload);
      } else if (selectedItemType === 2) {
        getReport("SUM_WHDOC_2", payload);
      } else {
        getReport("SUM_WHDOC_1", payload);
      }

      handleItemClose();
    } catch (e) {
      getAlert("FAILED", e?.message || String(e));
    }
  };

  const getDefaultItemType = () => {
    const mode = localStorage.getItem("TreasuryDocumentsMode");
    switch (mode) {
      case "FA":
        return 1;
      case "FT":
        return 2;
      case "WDP":
        return 3;
      default:
        return 1; // ค่า default ถ้าไม่มีใน localStorage
    }
  };

  const [selectedItemType, setSelectedItemType] = useState(
    getDefaultItemType()
  );
  const tabItems = [
    { value: 1, label: "ใบปรับปรุงสินค้า" },
    { value: 2, label: "ใบโอนย้าย" },
    { value: 3, label: "ใบเบิก" },
  ];
  const handleTabChange = (value) => {
    if (value === selectedItemType) return;
    clearDetail();
    setSelectedItemType(value);
  };
  const createButtonConfig =
    selectedItemType === 2
      ? { mode: "FT", label: "สร้างใบโอนย้าย" }
      : selectedItemType === 3
      ? { mode: "WDP", label: "สร้างใบเบิกสินค้า" }
      : { mode: "FA", label: "สร้างใบปรับปรุงสินค้า" };
  const isCreateDisabled = warehouse_Id === "3" && Emp_Position !== "1";

  const handleChangeDate = (value, name) => {
    let newValue =
      value && value instanceof moment ? value.format("YYYY-MM-DD") : value;

    // แปลงปี พ.ศ. ➜ ค.ศ. (ถ้าปีมากกว่า 2500)
    const [year, month, day] = newValue.split("-");
    const convertedDate = `${
      parseInt(year) > 2500 ? parseInt(year) - 543 : year
    }-${month}-${day}`;

    if (name === "fromDate") {
      setFromDate(newValue);
    } else {
      setToDate(convertedDate);
    }
  };

  const handleRemoveImage = (index) => {
    setSelectedFiles((prev) => prev.filter((_, i) => i !== index));
    if (selectedFiles.length === 0) {
      setOpenUploadAttach(false);
    }
  };

  const onRowSelected = async (fromData) => {
    setSelectedLeftDocId(fromData?.WHDoc_Id ?? null);
    const filteredDetail = dataDetailList.filter(
      (data) => parseCurrency(data.WHDoc_Id) === fromData.WHDoc_Id
    );

    if (filteredDetail && filteredDetail.length > 0) {
      setFilteredDetailList(filteredDetail);
      const files = await getDataWithComp(
        "Upload_File_List",
        `AND DocCode_ID = ${
          selectedItemType === 1 ? 16 : selectedItemType === 2 ? 17 : 18
        } AND Doc_ID = ${fromData.WHDoc_Id} AND File_Status = 'Y'`
      );
      if (files && files.length > 0) {
        const formattedFiles = files.map((file) => ({
          F_Id: file.F_Id,
          fileName: file.File_Name,
          File_Url: file.File_Name,
          uploadDate: file.Upload_Date,
          uploadBy: file.Upload_By,
        }));
        setSelectedFiles(formattedFiles);
        // setShowFileModal(true);
      } else {
        setSelectedFiles([]);
      }
      // setShowFileModal(true);
      // console.debug("files", files);
    } else {
      setFilteredDetailList([]);
    }

    setWhDocNo(fromData.WHDoc_No);

    if (selectedItemType) {
      setFromWhId(filteredDetail[0]?.F_WH_Id);
      setFromWhName(filteredDetail[0]?.F_WH_Name);
      setToWhId(filteredDetail[0]?.T_WH_Id);
      setToWhName(filteredDetail[0]?.T_WH_Name);
      setRemarkWhName(filteredDetail[0]?.WHDoc_Remark);
    }
  };

  // ทดสอบการทำค้นหาโดย SpriteZadis (ยังไม่สมบูรณ์ เดี๋ยวมาทำต่อ)
  const [searchItemTerm, setSearchItemTerm] = useState("");
  const filterDataByDate = (data) => {
    const from = fromDate
      ? moment(fromDate, "YYYY-MM-DD").startOf("day")
      : null;
    const to = toDate ? moment(toDate, "YYYY-MM-DD").endOf("day") : null;

    const docDate = moment(data.WHDoc_CreatedDate, "YYYY-MM-DD HH:mm:ss.SSS");

    return (
      (!from || docDate.isSameOrAfter(from)) &&
      (!to || docDate.isSameOrBefore(to))
    );
  };

  const filteredItemData = dataMasterList.filter((data) => {
    // ตรวจสอบการค้นหาตามหมายเลขและชื่อประเภทเอกสาร
    const searchTerm = (searchItemTerm || "").toLowerCase();

    const matchesItemSearchTerm =
      (data?.WHDoc_No || "").toLowerCase().includes(searchTerm) ||
      (data?.WHDocType_Name || "").toLowerCase().includes(searchTerm);

    // ตรวจสอบการกรองตามประเภทเอกสาร
    const matchesItemType = selectedItemType
      ? data.WHDoc_Type === selectedItemType
      : true;

    // ตรวจสอบการกรองตามวันที่
    const matchesDateRange = filterDataByDate(data);

    return matchesItemSearchTerm && matchesItemType && matchesDateRange;
  });
  console.debug("filteredItemData", filteredItemData);

  const handleFileSelection = (event) => {
    const files = Array.from(event.target.files);

    if (files.length === 0) return;

    const filePromises = files.map((file, index) => {
      return new Promise((resolve) => {
        const reader = new FileReader();

        reader.onload = (e) => {
          resolve({
            id: Date.now() + index + Math.random(),
            name: file.name,
            type: file.type,
            size: file.size,
            file: file,
            dataUrl: e.target.result,
            isPending: true,
            displayName: file.name,
          });
        };

        reader.onerror = () => {
          resolve({
            id: Date.now() + index + Math.random(),
            name: file.name,
            type: file.type,
            size: file.size,
            file: file,
            dataUrl: URL.createObjectURL(file),
            isPending: true,
            displayName: file.name,
            useObjectUrl: true,
          });
        };

        reader.readAsDataURL(file);
      });
    });

    Promise.all(filePromises)
      .then((processedFiles) => {
        const updatedFiles = [...selectedFiles, ...processedFiles];
        setSelectedFiles(updatedFiles);
        setShowFileModal(true); // ✅ แสดง modal ได้เลย ไม่ต้องเรียก handleInputFileChange
      })
      .catch((error) => {});

    event.target.value = "";
  };

  const handleBeforeUploadAttach = async () => {
    // URL ที่ไม่ต้องการให้มีการอัปโหลดซ้ำ
    const INVALID_BASE_URL =
      "https://23samuiice2024.s3.ap-southeast-1.amazonaws.com/SO_H/";

    // ดึงไฟล์ที่อัปโหลดแล้ว (isUploaded = true)
    const uploadedFileNames = new Set(
      selectedFiles
        .filter((file) => file.isUploaded)
        .map((file) => file.name?.toLowerCase())
    );

    // เลือกไฟล์ที่ยังไม่ได้อัปโหลด
    const filesToUpload = selectedFiles.filter((file) => {
      const isPending = file.isPending && !file.isUploaded;
      const isNotDuplicate = !uploadedFileNames.has(file.name?.toLowerCase());
      const isValidName =
        typeof file.name === "string" &&
        !file.name.startsWith(INVALID_BASE_URL);

      return isPending && isNotDuplicate && isValidName;
    });

    if (filesToUpload.length === 0) {
      getAlert("WARNING", "ไม่มีไฟล์ใหม่สำหรับอัปโหลด หรือไฟล์ซ้ำ/ไม่ถูกต้อง");
      return;
    }

    try {
      const filesWithBase64 = filesToUpload.map((file) => ({
        id: file.id,
        name: file.name,
        type: file.type,
        size: file.size,
        dataUrl: file.dataUrl,
        displayName: file.displayName || file.name,
      }));

      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/upload-file`,
        {
          comp_id: localStorage.getItem("company"),
          doc_id: filteredDetailList[0]?.WHDoc_Id,
          DocCode_ID:
            selectedItemType === 1 ? 16 : selectedItemType === 2 ? 17 : 18,
          upload_by: localStorage.getItem("name") || "system",
          file_status: "Y",
          files: filesWithBase64,
          doc_no_ref: null,
        },
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      const result = response.data;

      if (!result || result.status !== "SUCCESS") {
        throw new Error(result.message || "อัปโหลดล้มเหลว");
      }

      // อัปเดตสถานะไฟล์
      const updatedFiles = selectedFiles.map((file) => {
        const justUploaded = filesToUpload.find(
          (f) => f.name?.toLowerCase() === file.name?.toLowerCase()
        );
        return justUploaded
          ? { ...file, isUploaded: true, isPending: false }
          : file;
      });

      setSelectedFiles(updatedFiles);
      getAlert("OK", "อัปโหลดไฟล์สำเร็จ");
      setShowFileModal(false);
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      console.error("Upload error:", error);
      getAlert(
        "FAILED",
        error.response?.data?.message ||
          error.message ||
          "เกิดข้อผิดพลาดในการอัปโหลดไฟล์"
      );
    }
  };

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const mode = localStorage.getItem("TreasuryDocumentsMode");
    switch (mode) {
      case "FA":
        setSelectedItemType(1);
        break;
      case "FT":
        setSelectedItemType(2);
        break;
      case "WDP":
        setSelectedItemType(3);
        break;
      default:
        setSelectedItemType(1);
    }
  }, []);

  useEffect(() => {
    console.debug("filteredDetailList updated =>", filteredDetailList);
  }, [filteredDetailList]);

  return (
    <>
      <Breadcrumbs
        page={name}
        items={[
          { name: "คลังสินค้า", url: "/Warehouse" },
          { name: name, url: "/treasury-documents" },
        ]}
      />
      <div
        className="container-fluid card py-3"
        style={{ maxHeight: "85vh", overflowY: "auto", overflowX: "hidden", paddingLeft: "15px", paddingRight: "15px" }}
      >
        {isSmallScreen < 1749 ? (
          <div style={{ paddingLeft: "15px", paddingRight: "15px" }}>
            {/* บรรทัดแรก: ปุ่ม */}
            <div
              className="mb-2"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "nowrap",
                width: "100%",
                gap: "10px",
              }}
            >
              <div className="d-flex align-items-center" style={{ flexShrink: 0, gap: "8px" }}>
                {tabItems.map((tab, index) => (
                  <button
                    key={tab.value}
                    type="button"
                    className="btn treasury-tab-btn"
                    onClick={() => handleTabChange(tab.value)}
                    style={{
                      border: "1px solid #E13F57",
                      backgroundColor:
                        selectedItemType === tab.value
                          ? "rgb(225, 63, 87)"
                          : "#fff",
                      color:
                        selectedItemType === tab.value ? "#fff" : "#E13F57",
                      whiteSpace: "nowrap",
                      padding: "0.375rem 0.75rem",
                      fontSize: "15px",
                    }}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
              <div className="d-flex align-items-center" style={{ flexShrink: 0 }}>
                <button
                  className="btn text-white"
                  onClick={() => handleItemShow()}
                  style={{
                    display: "none",
                    backgroundColor: "rgb(225, 63, 87)",
                    whiteSpace: "nowrap",
                    padding: "10px",
                    fontSize: "15px",
                  }}
                >
                  <i className="fa fa-print me-2"></i>
                  {selectedItemType === 3
                    ? "พิมม์สรุปใบเบิกสินค้า"
                    : selectedItemType === 2
                    ? "พิมพ์สรุปใบโอนย้าย"
                    : "พิมพ์สรุปใบปรับปรุงสินค้า"}
                </button>
                <ItemWhModal
                  showItemModal={showItemModal}
                  handleItemClose={handleItemClose}
                  formDetailList={formDetailList}
                  onRowSelectItem={onRowSelectItem}
                  dataList={dataMasterList}
                />
              </div>
            </div>
            {/* บรรทัดที่สอง: Search, Radio และ Date */}
            <div className="row mb-2 align-items-center">
              <div className="d-flex align-items-center gap-3 flex-wrap">
                <div className="input-group treasury-filter-control" style={{ width: "300px" }}>
                  <span className="input-group-text">Search</span>
                  <input
                    type="text"
                    className="form-control"
                    value={searchItemTerm || ""}
                    onChange={(e) => setSearchItemTerm(e.target.value)}
                  />
                </div>
                <div className="d-flex align-items-center">
                  <button
                    className="btn text-white treasury-action-btn"
                    onClick={() => onChangeMode(createButtonConfig.mode)}
                    style={{
                      backgroundColor: "rgb(225, 63, 87)",
                      whiteSpace: "nowrap",
                      padding: "0.375rem 0.75rem",
                      fontSize: "15px",
                    }}
                    disabled={isCreateDisabled}
                  >
                    <i className="fa fa-plus" aria-hidden="true"></i>{" "}
                    {createButtonConfig.label}
                  </button>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <div className="d-flex align-items-center treasury-date-control">
                    <span className="input-group-text" style={{ whiteSpace: "nowrap" }}>
                      จากวันที่สร้าง
                    </span>
                    <div style={{ width: "130px", position: "relative" }}>
                      <Datetime
                        name="fromDate"
                        value={
                          fromDate
                            ? moment(fromDate).add(543, "years")
                            : null
                        }
                        onChange={(date) =>
                          handleChangeDate(
                            moment(date).subtract(543, "years"),
                            "fromDate"
                          )
                        }
                        dateFormat="DD-MM-YYYY"
                        timeFormat={false}
                        inputProps={{ readOnly: true, disabled: false }}
                      />
                    </div>
                  </div>
                  <div className="d-flex align-items-center treasury-date-control">
                    <span className="input-group-text" style={{ whiteSpace: "nowrap" }}>
                      ถึงวันที่สร้าง
                    </span>
                    <div style={{ width: "130px", position: "relative" }}>
                      <Datetime
                        name="toDate"
                        value={
                          toDate ? moment(toDate).add(543, "years") : null
                        }
                        onChange={(date) =>
                          handleChangeDate(
                            moment(date).subtract(543, "years"),
                            "toDate"
                          )
                        }
                        dateFormat="DD-MM-YYYY"
                        timeFormat={false}
                        inputProps={{ readOnly: true, disabled: false }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div style={{ paddingLeft: "15px", paddingRight: "15px" }}>
            {/* บรรทัดแรก: ปุ่ม */}
            <div
              className="mb-2"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "nowrap",
                width: "100%",
                gap: "10px",
              }}
            >
              <div className="d-flex align-items-center" style={{ flexShrink: 0, gap: "8px" }}>
                {tabItems.map((tab, index) => (
                  <button
                    key={tab.value}
                    type="button"
                    className="btn treasury-tab-btn"
                    onClick={() => handleTabChange(tab.value)}
                    style={{
                      border: "1px solid #E13F57",
                      backgroundColor:
                        selectedItemType === tab.value
                          ? "rgb(225, 63, 87)"
                          : "#fff",
                      color:
                        selectedItemType === tab.value ? "#fff" : "#E13F57",
                      whiteSpace: "nowrap",
                      padding: "0.375rem 0.75rem",
                      fontSize: "15px",
                    }}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
              <div className="d-flex align-items-center" style={{ flexShrink: 0 }}>
                <button
                  className="btn text-white"
                  onClick={() => handleItemShow()}
                  style={{
                    display: "none",
                    backgroundColor: "rgb(225, 63, 87)",
                    whiteSpace: "nowrap",
                    padding: "10px",
                    fontSize: "15px",
                  }}
                >
                  <i className="fa fa-print me-2"></i>
                  {selectedItemType === 3
                    ? "พิมม์สรุปใบเบิกสินค้า"
                    : selectedItemType === 2
                    ? "พิมพ์สรุปใบโอนย้าย"
                    : "พิมพ์สรุปใบปรับปรุงสินค้า"}
                </button>
                <ItemWhModal
                  showItemModal={showItemModal}
                  handleItemClose={handleItemClose}
                  formDetailList={formDetailList}
                  onRowSelectItem={onRowSelectItem}
                  dataList={dataMasterList}
                  selectedItemType={selectedItemType}
                  defaultSelectAll={true}
                />
              </div>
            </div>
            {/* บรรทัดที่สอง: Search, Radio และ Date */}
            <div className="row mb-2 align-items-center">
              <div className="d-flex align-items-center gap-3 flex-wrap">
                <div className="input-group treasury-filter-control" style={{ width: "300px" }}>
                  <span className="input-group-text">Search</span>
                  <input
                    type="text"
                    className="form-control"
                    value={searchItemTerm || ""}
                    onChange={(e) => setSearchItemTerm(e.target.value)}
                  />
                </div>
                <div className="d-flex align-items-center">
                  <button
                    className="btn text-white treasury-action-btn"
                    onClick={() => onChangeMode(createButtonConfig.mode)}
                    style={{
                      backgroundColor: "rgb(225, 63, 87)",
                      whiteSpace: "nowrap",
                      padding: "0.375rem 0.75rem",
                      fontSize: "15px",
                    }}
                    disabled={isCreateDisabled}
                  >
                    <i className="fa fa-plus" aria-hidden="true"></i>{" "}
                    {createButtonConfig.label}
                  </button>
                </div>
                <div className="d-flex align-items-center gap-2">
                  <div className="d-flex align-items-center treasury-date-control">
                    <span className="input-group-text" style={{ whiteSpace: "nowrap" }}>
                      จากวันที่สร้าง
                    </span>
                    <div style={{ width: "130px" }}>
                      <Datetime
                        name="fromDate"
                        value={
                          fromDate ? moment(fromDate).add(543, "years") : null
                        }
                        onChange={(date) =>
                          handleChangeDate(
                            moment(date).subtract(543, "years"),
                            "fromDate"
                          )
                        }
                        dateFormat="DD-MM-YYYY"
                        timeFormat={false}
                        inputProps={{ readOnly: true, disabled: false }}
                      />
                    </div>
                  </div>
                  <div className="d-flex align-items-center treasury-date-control">
                    <span className="input-group-text" style={{ whiteSpace: "nowrap" }}>
                      ถึงวันที่สร้าง
                    </span>
                    <div style={{ width: "130px" }}>
                      <Datetime
                        name="toDate"
                        value={toDate ? moment(toDate).add(543, "years") : null}
                        onChange={(date) =>
                          handleChangeDate(
                            moment(date).subtract(543, "years"),
                            "toDate"
                          )
                        }
                        dateFormat="DD-MM-YYYY"
                        timeFormat={false}
                        inputProps={{ readOnly: true, disabled: false }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="row" style={{ margin: 0 }}>
          <div
            className="col-6 mb-1"
            style={{ paddingLeft: 0, paddingRight: 0 }}
          >
            <div
              className="table-responsive"
              style={{ maxHeight: "650px", overflowY: "auto", overflowX: "auto" }}
            >
              <table
                id="basic-datatables"
                className="table table-striped table-hover treasury-docs-table"
                style={{ minWidth: "900px" }}
              >
                <thead className="thead-dark">
                  <tr>
                    <th className="text-center" style={{ width: "14%" }}>
                      เลขเอกสาร
                    </th>
                    <th className="text-center" style={{ width: "10%" }}>
                      ประเภท
                    </th>
                    <th className="text-center" style={{ width: "16%" }}>
                      คลังที่ปรับปรุง
                    </th>
                    <th className="text-center" style={{ width: "16%" }}>
                      วันที่สร้าง
                    </th>
                    <th className="text-center" style={{ width: "20%" }}>
                      หมายเหตุ
                    </th>

                    <th className="text-center" style={{ width: "14%" }}>
                      ชื่อผู้สร้าง
                    </th>
                    {selectedItemType === 3 && (
                      <th className="text-center" style={{ width: "5%" }}>
                        เลขเอกสารอ้างอิง
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {filteredItemData.length > 0 ? (
                    filteredItemData.map((data, index) => (
                      <tr
                        key={data.WHDoc_Id || index + 1}
                        onClick={() => onRowSelected(data)}
                        style={{ cursor: "pointer" }}
                        className={
                          selectedLeftDocId === data.WHDoc_Id
                            ? "treasury-row-active"
                            : ""
                        }
                      >
                        <td className="text-center">{data.WHDoc_No}</td>
                        <td className="text-center">{data.WHDocType_Name}</td>
                        <td className="text-center">{data.F_WH_Name}</td>
                        <td className="text-center">
                          {moment(data.WHDoc_CreatedDate)
                            .add(543, "years")
                            .subtract(7, "hours")
                            .format("DD-MM-YYYY HH:mm")}
                        </td>
                        <td className="text-left">{data.WHDoc_Remark}</td>
                        <td className="text-center">{data.WHDoc_CreatedBy}</td>
                        {selectedItemType === 3 && (
                          <td className="text-center"></td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="2">
                        <center>
                          <h5>ไม่พบข้อมูล</h5>
                        </center>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-6 mb-3">
            <TeasuryTable dataList={filteredDetailList} />
            <FileModalV2
              mode="U" // โหมดดูอย่างเดียว
              showViewAttachModal={showFileModal}
              setShowViewAttachModal={setShowFileModal}
              selectedFiles={selectedFiles}
              setSelectedFiles={setSelectedFiles}
              selectedRecFiles={[]}
              openUploadAttach={openUploadAttach}
              handleRemoveImage={handleRemoveImage}
              handleBeforeUploadAttach={handleBeforeUploadAttach}
            />
          </div>
        </div>
      </div>
      <style>{`
        .form-check-input {
          cursor: pointer;
        }
        .form-check-label {
          cursor: pointer;
          user-select: none;
        }
        .treasury-row-active td {
          background: #FDECEF !important;
          border-top: 2px solid #E13F57 !important;
          border-bottom: 2px solid #E13F57 !important;
        }
        .treasury-row-active td:first-child {
          border-left: 4px solid #E13F57 !important;
        }
        .treasury-docs-table td,
        .treasury-docs-table th {
          white-space: nowrap;
        }
        .input-group-text {
          background-color: #f8f9fa;
          border: 1px solid #ced4da;
          font-weight: 500;
          min-width: fit-content;
        }
        .treasury-date-control .input-group-text,
        .treasury-date-control .rdt input,
        .treasury-filter-control .input-group-text,
        .treasury-filter-control .form-control,
        .treasury-action-btn,
        .treasury-tab-btn {
          height: 36px;
          padding: 0.375rem 0.75rem;
        }
        .treasury-action-btn,
        .treasury-tab-btn {
          font-size: 15px;
        }
        .rdt {
          display: inline-block;
          position: relative;
        }
        .rdt input {
          border: 1px solid #ced4da;
          border-radius: 0.375rem;
          padding: 0.375rem 0.75rem;
          width: 100%;
        }
        .rdt input:focus {
          border-color: #86b7fe;
          outline: 0;
          box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
        }
        .rdtPicker {
          position: absolute !important;
          z-index: 1050 !important;
          background: white !important;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
          margin-top: 5px !important;
        }
        .rdt {
          position: relative !important;
        }
      `}</style>
    </>
  );
};

export default Main;
